import { getApolloClient, analyticsPersistor, apolloPersistor } from 'services';
import { inImpersonateMode, isChromeExtension } from 'helpers/constants';

export function purgeAndReload() {
  getApolloClient().then((apollo) => {
    apollo.clearStore();
    apolloPersistor.purge().then(() => {
      analyticsPersistor.purge().then(() => {
        window.location.reload();
      });
    });
  });
}

export function handleFlagChange() {
  if (isChromeExtension && !inImpersonateMode) {
    chrome.tabs.query({}, (tabs) => {
      const regex = new RegExp(`${chrome.runtime.id}`);
      const chromeTabs = tabs.filter(
        (tab) =>
          !tab.incognito && (regex.test(tab.url as string) || tab.url?.includes('chrome://newtab/'))
      );
      for (var i = 0; i < chromeTabs.length; i++) {
        chrome.tabs.sendMessage(chromeTabs[i].id as number, { action: 'purge_and_reload' });
      }
    });
    return;
  }
}
